import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { vehicleDriverAssignmentTransitionRefs } from "../subjects/vehicleDriverAssignmentTransition/refs";

/**
 * The seat a driver holds on a unit.
 *
 * `primary` is the seat holder — the driver at the wheel, or the first aboard before anyone has driven — and
 * `secondary` the co-driver. A driver holds at most one seat at a time, and a change of seat is a detach followed by
 * an attach at the same instant, never a field that flips.
 */
export const AssignmentRoleSchema = z.enum(["primary", "secondary"]).openapi("AssignmentRole");

export type AssignmentRole = z.infer<typeof AssignmentRoleSchema>;

/**
 * The driver took a seat on the unit.
 *
 * No direction field: the kind is the direction, and `vehicleDetached` is its opposite.
 */
export const vehicleAttachedV1 = tmsEventKind(
  { category: "vehicleAssignment", kind: "vehicleAttached", version: 1 },
  { refs: vehicleDriverAssignmentTransitionRefs, facts: { role: AssignmentRoleSchema } },
);

export const VehicleAttachedV1Schema = vehicleAttachedV1.schema;
export const VehicleAttachedV1FactsSchema = vehicleAttachedV1.facts;

export type VehicleAttachedV1 = z.infer<typeof VehicleAttachedV1Schema>;
export type VehicleAttachedV1Facts = z.infer<typeof VehicleAttachedV1FactsSchema>;

/** Every version of `vehicleAttached`, keyed by version. What `catalog.ts` places under `vehicleAssignment`. */
export const vehicleAttached = { 1: vehicleAttachedV1 } as const;
